import styled from 'styled-components';
import { ColorAddiBlack, ColorAddiWhite } from '@addi/foundation/dist/web/colors';
export const CountrySelectorContainer = styled.div `
  min-width: ${({ withLabel }) => (withLabel ? '110px' : '40px')};
  position: relative;
`;
export const CountrySelected = styled.div `
  cursor: pointer;
  min-width: 110px;
  max-height: 31px;
  color: ${ColorAddiWhite};
  display: flex;
  text-decoration: none;
  :after {
    display: inline-block;
    margin-top: 2px;
    margin-left: 4px;
    align-self: center;
    content: '';
    background-image: url('https://statics.addi.com/ui-storybook/chevron.svg');
    background-size: contain;
    background-repeat: no-repeat;
    width: 12.02px;
    height: 7.42px;
  }
  :hover {
    color: ${ColorAddiBlack};
  }
`;
//# sourceMappingURL=country-selector.styled.js.map